import { SupportChatActions } from './types'

let activeProvider: SupportChatActions | null = null

export const registerSupportChatProvider = (provider: SupportChatActions) => {
  activeProvider = provider
}

export const clearSupportChatProvider = (provider?: SupportChatActions) => {
  if (!provider || activeProvider === provider) {
    activeProvider = null
  }
}

export const openSupportChat = () => {
  activeProvider?.open()
}

export const disableSupportChat = () => {
  activeProvider?.disable()
}

export const enableSupportChat = () => {
  activeProvider?.enable()
}

export const logoutSupportChat = () => {
  activeProvider?.logout()
}
